import moment from 'moment'
import maInputText from '@/components/input/modules/text'

export default {
  name: 'datePicker',
  props: {
    type: {
      required: false,
      default: 'normal',
      type: String
    },

    handleChangeInput: {
      required: true,
      type: Function
    },
    literal: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },

    dateMax: {
      type: Date,
      required: false
    },

    dateMin: {
      type: Date,
      required: false
    },

    clickInputStart: {
      required: false,
      type: Function
    },

    defaultValue: {
      required: false,
      type: String
    },

    cleanData: {
      default: false,
      required: false,
      type: Boolean
    },

    weekDays: {
      required: false,
      type: Array
    },

    format: {
      required: false,
      type: String,
      default: 'DD/MM/YYYY'
    }

  },
  data () {
    return {
      date: null,
      locale: localStorage.getItem('__ui_settings_locale__'),
      dateMask: {
        input: [this.format]
      },
      datePopover: {
        'visibility': 'click'
      },
      minDate: null,
      maxDate: new Date(),
      value: '',
      isExpanded: true,
      days: this.weekDays ? this.weekDays : []
    }
  },
  components: {
    maInputText
  },
  methods: {
    setMinDate () {
      this.minDate = moment().subtract(20, 'year').format('YYYY/MM/DD')
    }
  },
  mounted () {
    this.localeToCalendarLang()
    this.setMinDate()
    this.setMaxDate()
  }

}
